const Images = {
    logo: `/images/logos/ttg.svg`,
    logoWhite: `/images/logos/ttg-white.svg`,
    report: {
        pyramid: `/images/ttg/report/pyramid.svg`,
        pyramidWhiteFill: `/images/ttg/report/pyramid-white-fill.svg`,
        pyramidGrayedOut: `/images/ttg/report/pyramid-grayed-out.svg`,
        logo5d: `/images/ttg/report/5d-logo.png`,
        poweredByTg: `/images/ttg/report/powered-by-tg.png`,
        chatBox: `/images/ttg/report/chatbox.svg`,
        pageTriangle: `/images/ttg/report/pageTriangle.svg`,
        fullMarkColorLogo: `/images/ttg/report/Table-Group-Logo-Fullmark-Color.jpg`,
        gears: `/images/ttg/report/gears.svg`,
        emblem: `/images/ttg/report/emblem.svg`,
        flag: `/images/ttg/report/flag.svg`,
        checkmark: `/images/ttg/report/checkmark.svg`,
        close: `/images/ttg/report/close.svg`,
        exclamation: `/images/ttg/report/exclamation.svg`,
        puzzlePieces: `/images/ttg/report/puzzle-pieces.svg`,
        lightbulb: `/images/ttg/report/lightbulb.svg`,
        arrow: `/images/ttg/report/arrow.svg`,
        the5d: {
            1: `/images/ttg/report/01.svg`,
            2: `/images/ttg/report/02.svg`,
            3: `/images/ttg/report/03.svg`,
            4: `/images/ttg/report/04.svg`,
            5: `/images/ttg/report/05.svg`,
        },
    },
    ohsPdf: {
        logo: `/images/ttg/TG_logo.jpg`,
        book: `/images/ttg/meeting_advantage_book.png`
    },
};

export default Images;
